import Hammer from 'hammerjs'

const SERVICE_ACTIVE = 'Service--active';
const event = false
const state = {
  activeElement: false
}

function ServiceBlock(element) {
  this.block = element;
  this.hammer = new Hammer(element)

  PreventGhostClick(this.block)

  this.hammer.on('tap', this.tapHandler.bind(this))
  this.event = new CustomEvent('services.tap')

  this.block.addEventListener('services.tap', (e) => {
    if (e.target.id == state.activeElement) {
      Turbolinks.visit(e.target.href)
    }

    if (e.target.id != state.activeElement) {
      state.activeElement = e.target.id
      e.target.classList.add(SERVICE_ACTIVE)
    }
  })

  document.addEventListener('touchend', (e) => {
    e.preventDefault()
    e.stopPropagation()
  })
}

ServiceBlock.prototype.tapHandler = function (ev) {
  this.block.dispatchEvent(this.event)
}

document.removeEventListener('turbolinks:load', init)
document.addEventListener('DOMContentLoaded', init)
document.addEventListener('turbolinks:load', init)

function init() {
  let services = [].slice.call(
    document.querySelectorAll('.Service')
  )

  services.forEach(s => new ServiceBlock(s))
}



/** WEBPACK FOOTER **
 ** ./assets/js/pages/services.js
 **/